<template>
  <div class="statistics">
    <div class="staTitle">
      <span>{{text.title}}</span>
      <span v-if="haveList" style="cursor: pointer" @click="searchList">
        <i class="el-icon-s-grid"></i>
        {{text.ChangeTitle||text.bTitle}}
      </span>
    </div>
    <ul>
      <li v-for="(item,ind) in defaultText" :key="ind">
        <div class="name">{{item.name}}</div>
        <div class="num">
          {{dataList[item.type]||0}}
          <span>{{item.unit||"秒"}}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: Object,
      default: { title: "", bTitle: ""}
    },
    haveList: {
      type: Boolean,
      default: true
    },
    dataList: {
      type: Object,
      default: {}
    },
    defaultText: { type: Array, default: [] }
  },
  methods: {
    searchList() {
      this.$emit("showSearchtable", this.text);
    }
  },
  created() {
    // console.log(this.defaultText)
    // console.log(this.dataList)

  }
};
</script>

<style lang="scss" scoped>
.staTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>